module.exports = __webpack_public_path__ + "static/media/gmodquartet.3ca0c4cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gmodquartet.png
// module id = 271
// module chunks = 0